export default "__VITE_ASSET__BPSiMrzf__"